module.exports = {
	"ha": "fha",
	"id": 5.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 83.47107438016529,
						"dataLabels": {
							"enabled": true,
							"format": "101",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.900826446281,
						"dataLabels": {
							"enabled": true,
							"format": "87",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.94214876033058,
						"dataLabels": {
							"enabled": true,
							"format": "81",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 61.15702479338842,
						"dataLabels": {
							"enabled": true,
							"format": "74",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 36.36363636363637,
						"dataLabels": {
							"enabled": true,
							"format": "44",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.40764331210191,
						"dataLabels": {
							"enabled": true,
							"format": "309",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.62420382165605,
						"dataLabels": {
							"enabled": true,
							"format": "272",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.52866242038218,
						"dataLabels": {
							"enabled": true,
							"format": "256",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.20382165605095,
						"dataLabels": {
							"enabled": true,
							"format": "233",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.22929936305732,
						"dataLabels": {
							"enabled": true,
							"format": "164",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 99.43714821763602,
						"dataLabels": {
							"enabled": true,
							"format": "530",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.11632270168855,
						"dataLabels": {
							"enabled": true,
							"format": "459",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.23827392120076,
						"dataLabels": {
							"enabled": true,
							"format": "433",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.671669793621,
						"dataLabels": {
							"enabled": true,
							"format": "398",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.09568480300187,
						"dataLabels": {
							"enabled": true,
							"format": "283",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 99.85714285714286,
						"dataLabels": {
							"enabled": true,
							"format": "1398",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.71428571428571,
						"dataLabels": {
							"enabled": true,
							"format": "1228",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.64285714285714,
						"dataLabels": {
							"enabled": true,
							"format": "1171",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.57142857142857,
						"dataLabels": {
							"enabled": true,
							"format": "1114",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.21428571428571,
						"dataLabels": {
							"enabled": true,
							"format": "843",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -16.528925619834713,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.861386138613863,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.64197530864198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -40.54054054054054,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.5923566878980888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.97411003236246,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.984375,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -29.613733905579398,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -0.5628517823639823,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.396226415094336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.664488017429193,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.083140877598149,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -28.894472361809044,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -0.14285714285714457,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.160228898426329,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.641693811074921,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.867634500426988,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -24.326750448833035,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=121"
			},
			{
				"x": 9,
				"text": "30–39<br>n=314"
			},
			{
				"x": 15,
				"text": "40–49<br>n=533"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=1400"
			}
		],
		"dataTable": {
			"< 30": [
				121,
				101,
				87,
				81,
				74,
				44
			],
			"30–39": [
				314,
				309,
				272,
				256,
				233,
				164
			],
			"40–49": [
				533,
				530,
				459,
				433,
				398,
				283
			],
			"≥ 50": [
				1400,
				1398,
				1228,
				1171,
				1114,
				843
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_3.json
// module id = 202
// module chunks = 0